import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PendingSellerChange, SellerChangePage } from '../models/pending-seller-change.model';
import { environment } from '../../environments/environment';

/**
 * Seller business-profile changes awaiting review — SubscriptionManagement
 * api/admin/business-changes (marketplaceReview policy). An approved seller's
 * UpdateBusiness queues here; approving applies the payload through the normal
 * update path.
 */
@Injectable({ providedIn: 'root' })
export class PendingSellerChangeService {
  /** Server-enforced ceiling: admin lists return at most 12 rows per request. */
  static readonly PAGE_SIZE = 12;

  private readonly baseUrl = environment.subscriptionApiUrl + '/api/admin/business-changes';

  constructor(private http: HttpClient) {}

  getPendingChanges(pageNumber: number, businessId?: string): Observable<SellerChangePage> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', PendingSellerChangeService.PAGE_SIZE)
      .set('status', 'Pending');
    if (businessId?.trim()) {
      params = params.set('businessId', businessId.trim());
    }
    return this.http.get<SellerChangePage>(`${this.baseUrl}/GetChanges`, { params });
  }

  approveChange(id: string): Observable<PendingSellerChange> {
    return this.http.post<PendingSellerChange>(`${this.baseUrl}/${encodeURIComponent(id)}/approve`, {});
  }

  rejectChange(id: string, reason: string): Observable<PendingSellerChange> {
    return this.http.post<PendingSellerChange>(`${this.baseUrl}/${encodeURIComponent(id)}/reject`, { reason });
  }
}
